import {ENDPOINT_URL} from '../constants';
import getFetchOptions from '../utils/getFetchOptions';
import {apiErrorHandling} from '../utils/apiUtils';

const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function verifyAdminCustom(testAdmin) {
	return fetch(
		`${ENDPOINT_URL}/customverification`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify(testAdmin),
		})
	).then(async (res) => {
		// try to parse JSON, but don’t crash if body is empty/non-JSON
		let data = null;
		try {
			data = await res.json();
		} catch {
			/* ignore */
		}

		if (!res.ok) {
			// Normalize error shape for callers
			console.log('res', res);
			const msg = data?.error || `HTTP_${res.status}`;
			console.log('msg ', msg);
			return Promise.reject({status: res.status, error: msg});
		}

		return data ?? {};
	});
}
